export var ButtonPriority;
(function (ButtonPriority) {
    ButtonPriority["basic"] = "basic";
    ButtonPriority["primary"] = "primary";
    ButtonPriority["secondary"] = "secondary";
    ButtonPriority["basicSecondary"] = "basicSecondary";
})(ButtonPriority || (ButtonPriority = {}));
export var ButtonSize;
(function (ButtonSize) {
    ButtonSize["tiny"] = "tiny";
    ButtonSize["small"] = "small";
    ButtonSize["medium"] = "medium";
    ButtonSize["large"] = "large";
})(ButtonSize || (ButtonSize = {}));
export var AffixTypes;
(function (AffixTypes) {
    AffixTypes["prefix"] = "prefix";
    AffixTypes["suffix"] = "suffix";
})(AffixTypes || (AffixTypes = {}));
export var PaddingModes;
(function (PaddingModes) {
    PaddingModes["legacy"] = "legacy";
    PaddingModes["dynamicPaddings"] = "dynamicPaddings";
    PaddingModes["explicitPaddings"] = "explicitPaddings";
})(PaddingModes || (PaddingModes = {}));
//# sourceMappingURL=types.js.map